import React, { useEffect, useState } from "react";
import { CONTACT_MEDIUM, CONTACT_URL } from "../constant/constants";
import CopyrightComponent from "../component/CopyrightComponent";
import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();
  const [formPosition, setFormPosition] = useState({
    marginTop: "50px",
  });

  useEffect(() => {
    calculateCenter();
  }, []);

  const calculateCenter = () => {
    const loginFormHeight = document.getElementById("login-form").offsetHeight;
    const mainFormHeight = document.getElementById("main-form").offsetHeight;
    let freeHeight = (mainFormHeight - loginFormHeight) / 3;
    setFormPosition({
      marginTop: `${freeHeight}px`,
    });
  };

  const handleContact = (contactMedium) => {
    switch (contactMedium) {
      case CONTACT_MEDIUM.CALL:
        window.open(`${CONTACT_URL.CALL_URL}`, "_blank", "noopener,noreferrer");
        break;
      case CONTACT_MEDIUM.WHATSAPP:
        window.open(`${CONTACT_URL.WHATSAPP_URL}`, "_blank", "noopener,noreferrer");
        break;
      case CONTACT_MEDIUM.MESSENGER:
        window.open(`${CONTACT_URL.MESSENGER_URL}`, "_blank", "noopener,noreferrer");
        break;
      default:
        break;
    }
  };

  return (
    <div id="main-form" style={{ height: "100vh" }} className="flex flex-col items-center p-[50px] bg-yellow">
      <div
        id="login-form"
        style={formPosition}
        className="flex w-[360px] flex-col lg:w-[400px] bg-white justify-center border-[1px] border-gray-300 rounded-[5px] p-[20px]"
      >
        <div className="w-full h-[60px] flex flex-row mb-[10px] items-center justify-start gap-x-[5%]">
          <img className="w-auto h-full" src={`/images/icons/TableTap_icon.svg`} />
          <div className="w-auto h-full content-center">
            <img src={`/images/Scan_Order_Savor.png`} />
          </div>
        </div>

        <div className="flex flex-col items-center justify-center  bg-gray-100 text-center pb-5 mt-5">
          <h1 className="text-6xl font-bold text-red-600 mb-4">404</h1>
          <p className="text-xl text-gray-600 mb-8">Oops! The page you’re looking for doesn’t exist.</p>
          <button
            onClick={() => navigate("/")}
            className="px-6 py-3 bg-yellow text-black rounded-2xl shadow-md transition"
          >
            Go Back Home
          </button>
        </div>

        <div className="w-full px-[16px] mt-10">

          <div className="text-center font-medium">Contact For Support</div>

          <div className="w-full h-[40px] mt-[10px] flex flex-row flex-nowrap items-center justify-center gap-x-[23px]">
            <div onClick={() => handleContact(CONTACT_MEDIUM.CALL)} className="w-[40px] h-full cursor-pointer">
              <img src={`/images/icons/call_icon.svg`} alt="Call Icon" />
            </div>

            <div className="w-[40px] h-full cursor-pointer" onClick={() => handleContact(CONTACT_MEDIUM.WHATSAPP)}>
              <img src={`/images/icons/whatsapp_icon.svg`} alt="Whatsapp Icon" />
            </div>

            <div className="w-[40px] h-full cursor-pointer" onClick={() => handleContact(CONTACT_MEDIUM.MESSENGER)}>
              <img src={`/images/icons/messenger_icon.svg`} alt="Messenger Icon" />
            </div>
          </div>
        </div>
      </div>

      <CopyrightComponent />
    </div>
  );
}

export default NotFound;
